import { useSyncExternalStore } from "react";

const STORAGE_KEY = "jukebox-volume-v1";

const isClient = () => typeof window !== "undefined";

const clamp = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return 1;
  }
  return Math.min(1, Math.max(0, num));
};

const getDefaultState = () => ({
  musicVolume: 1,
  metronomeVolume: 1,
});

const parseStoredState = () => {
  const defaults = getDefaultState();

  if (!isClient()) {
    return defaults;
  }

  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);

    if (!rawValue) {
      return defaults;
    }

    const parsed = JSON.parse(rawValue);

    return {
      musicVolume: clamp(parsed?.musicVolume ?? defaults.musicVolume),
      metronomeVolume: clamp(parsed?.metronomeVolume ?? defaults.metronomeVolume),
    };
  } catch {
    return defaults;
  }
};

let state = parseStoredState();
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => listener());
};

const persist = () => {
  if (!isClient()) {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

const setState = (nextState) => {
  state = nextState;
  persist();
  emit();
};

const subscribe = (listener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => state;

/** Снапшот для не-реактивного чтения (например, внутри аудио-колбэков). */
export const getJukeboxVolumes = () => state;

export const useJukeboxVolumeStore = () => {
  const volumes = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return {
    ...volumes,
    setMusicVolume: (musicVolume) => setState({ ...state, musicVolume: clamp(musicVolume) }),
    setMetronomeVolume: (metronomeVolume) =>
      setState({ ...state, metronomeVolume: clamp(metronomeVolume) }),
  };
};
